
import { contentConfig } from '../../../config/content/index'
export default {
  // 出行人核验信息
  contactVerifyParams: {},
  // 出行人列表
  contactList: [],
  // 证件列表
  cardTypeList: [],
  secretKey: '',
  // 选中出行人
  selectedContacts: [],
  // 出行人详情
  contactDetail: {},
  // 选中出行人的制度
  travelerRuleDetail: {},
  // 是否有权限
  permission: false,
  // 编辑更新的证件id
  refreshUserId: null,
  //出行人国籍
  nationality:{},
  //国家分组列表
  groupCountry:[],
  //端上自己维护的临时外部出行人全部数据
  externalContacts:[],
  //出行人必填检验配置
  contentConfig
}
